/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertShiftScheduleRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {UpsertShiftScheduleResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const upsertShiftSchedule = (request: UpsertShiftScheduleRequest, options?: CashRequestOptions) => post<UpsertShiftScheduleRequest, UpsertShiftScheduleResponse>("/2.0/cash/upsert-shift-schedule", request, {...options, rejectOnError: true })